import React from 'react';
import styled from 'styled-components';

type ColorProps = {
  children?: React.ReactNode;
};
const WrapWithColor = (props: ColorProps) => {
  return <Color>{props.children}</Color>;
};

const Color = styled.span`
  color: #aaa;
`;

export { WrapWithColor };
